<script type="text/ecmascript-6">
    import DesignerQuestionDoorColourInternal from "../DesignerQuestionDoorColourInternal.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionDoorColourInternal,
            SynsealTileQuestion
        ],
        props: {
            isCraftsman: {
                required: true
            }
        },
        computed: {
            thumbURL(){
                if (this.isCraftsman) {
                    return '/thumb/door-colour-2/';
                }
                return '/thumb/door-colour-' + this.frameMaterial + '/';
            },
        },
        mounted() {
            window.emitter.on('door-external-colour-updated', (new_colour) => {
                this.localTarget = new_colour;
            });
        },
        onUnmounted() {
            window.emitter.off('door-external-colour-updated');
        },
    }
</script>
